import {
  CrudTableViewConfig,
  CrudViewColumnType,
  InputSize
} from '@rappider/rappider-components/utils';

export const dataModelListGridConfig: CrudTableViewConfig = {
  columns: [
    {
      title: 'Field Name',
      fieldName: 'fieldName',
      type: CrudViewColumnType.Text,
      width: '200px',
      sortable: false
    },
    {
      title: 'Sample Data',
      fieldName: 'sampleData',
      type: CrudViewColumnType.Text,
      width: '250px',
      sortable: false,
      isListGridDataObject: true
    },
    {
      title: 'Description',
      fieldName: 'description',
      type: CrudViewColumnType.Text,
      sortable: false
    }
  ],
  showPagination: false,
  size: InputSize.Small,
  filterable: false,
  sortable: false,
  searchable: false,
  columnVisibilitySelectable: false,
  itemActions: [],
  listActions: []
};

export const currentModelListGridConfig: CrudTableViewConfig = {
  columns: [
    {
      title: 'Field Name',
      fieldName: 'name',
      type: CrudViewColumnType.Text,
      width: '200px',
      sortable: false
    },
    {
      title: 'Type',
      fieldName: 'type',
      type: CrudViewColumnType.Text,
      width: '150px',
      sortable: false
    },
    {
      title: 'Description',
      fieldName: 'description',
      type: CrudViewColumnType.Text,
      sortable: false
    }
  ],
  showPagination: false,
  size: InputSize.Small,
  filterable: false,
  sortable: false,
  searchable: false,
  columnVisibilitySelectable: false,
  itemActions: [],
  listActions: [],
  // Custom row class function for field status styling
  handleRowClassFn: (data: any) => {
    if (!data || !data.status) {
      return '';
    }

    switch (data.status) {
      case 'new':
        return 'field-new';
      case 'deleted':
        return 'field-deleted';
      case 'updated':
        return 'field-updated';
      default:
        return '';
    }
  }
};
